import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridAppearance} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {GridRendererRegistry} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridRendererRegistry';
import {FrameCellAreaStyles} from '@mintdata-wsp/wsp/ui/components/grid/appearance/frame/FrameCellAreaStyles';
import {GridAppearance} from '@mintdata-wsp/wsp/ui/components/grid/appearance/general/GridAppearance';
import {TextHeaderCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/columnHeader/TextHeaderCellRenderer';
import {FrameCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameCellRenderer';
import {FrameColumnHeaderRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameColumnHeaderRenderer';
import {FrameRowHeaderRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameRowHeaderRenderer';
import {TextCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/TextCellRenderer';

export class FrameAppearance
{
    public static create():IGridAppearance
    {
        const rr = new GridRendererRegistry();
        rr.register(GridCellKind.Text, new TextCellRenderer());
        rr.register(GridCellKind.TextHeader, new TextHeaderCellRenderer());

        rr.register(GridCellKind.FrameColumnHeader, new FrameColumnHeaderRenderer());
        rr.register(GridCellKind.FrameRowHeader, new FrameRowHeaderRenderer());
        rr.register(GridCellKind.FrameCell, new FrameCellRenderer());

        return new GridAppearance(FrameCellAreaStyles, rr);
    }
}
